module.exports = __webpack_public_path__ + "static/media/dries-buyataert.3919a6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/dries-buyataert.png
// module id = 217
// module chunks = 0